// extracted by mini-css-extract-plugin
export default {"container":"gn-z"};